import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default async ({ entityId, input }) => {
	const query = gql`
		mutation updateOrganization(
			$id: String!
			$input: updateOrganizationInput!
		) {
			updateOrganization(id: $id, updateOrganizationInput: $input) {
				status
				errors
			}
		}
	`
	const variables = {
		id: entityId,
		input
	}

	const res = await api({ query, variables })

	return Promise.resolve(res)
}
